import React from 'react'
import ReactResizeDetector from 'react-resize-detector'

import Text from './primitives/Text'

import Pl from '../i/flip_placeholder.svg'

/**
 * Flip card
 */
class FlipCards extends React.Component {
    constructor(props) {
        super(props)
        this.state = { flipped: false, width: 800 }
        this.onClick = this.onClick.bind(this)
    }

    onResize__container = width => {
        this.setState({ width })
    }

    onClick() {
        this.setState(prevState => {
            return { flipped: !prevState.flipped }
        })
    }

    render() {
        const {
            blockData: { frontColor, frontSrc, backColor, backSrc, frontText, backText, id },
            onUpdate,
            imageProportions,
        } = this.props
        const { flipped, width } = this.state
        const imgPrp = imageProportions.value.split('|')
        const st = {
            height: Math.round((width * +imgPrp[1]) / +imgPrp[0]) + 'px',
        }

        const frontSt = {
            backgroundColor: frontColor,
            backgroundImage: `url(${frontSrc})`,
        }
        if (!frontColor && !frontSrc) {
            // use placeholder
            frontSt.backgroundImage = `url(${Pl})`
        }

        const backSt = {
            backgroundColor: backColor,
            backgroundImage: `url(${backSrc})`,
        }
        if (!backColor && !backSrc) {
            // use placeholder
            backSt.backgroundImage = `url(${Pl})`
        }

        return (
            <div className={`block __${this.props.t}`} style={st}>
                <ReactResizeDetector
                    refreshMode="debounce"
                    refreshRate={0}
                    handleWidth
                    onResize={this.onResize__container}
                />
                <div className={`flip_inner ${flipped ? '__flipped' : ''}`}>
                    <div className="flip_side" style={frontSt}>
                        {frontText && (
                            <div className="text-area-cnt">
                                <div className="text-area">
                                    <Text id={id} text={frontText} propName={'frontText'} onUpdate={onUpdate}></Text>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="flip_side __back" style={backSt}>
                        {backText && (
                            <div className="text-area-cnt">
                                <div className="text-area">
                                    <Text id={id} text={backText} propName={'backText'} onUpdate={onUpdate}></Text>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className="flip_switch" onClick={this.onClick}>
                    <p className={!flipped ? 'active' : ''}>Front</p>
                    <p className={flipped ? 'active' : ''}>Back</p>
                </div>
            </div>
        )
    }
}

export default FlipCards
